import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FavoritedService {
  id: string;
  name: string;
  service_name?: string;
  price?: number;
  image?: string;
  provider?: string;
  rating?: number;
}

const FAVORITES_STORAGE_KEY = 'ots_favorites';

function loadFromStorage(): FavoritedService[] {
  try {
    const raw = localStorage.getItem(FAVORITES_STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return [];
}

function saveToStorage(items: FavoritedService[]) {
  try {
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(items));
  } catch {}
}

const initialState: FavoritedService[] = loadFromStorage();

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    addFavorite: (state, action: PayloadAction<FavoritedService>) => {
      const exists = state.some((s) => s.id === action.payload.id);
      if (!exists) {
        const next = [...state, action.payload];
        saveToStorage(next);
        return next;
      }
      return state;
    },
    removeFavorite: (state, action: PayloadAction<string>) => {
      const next = state.filter((s) => s.id !== action.payload);
      saveToStorage(next);
      return next;
    },
    toggleFavorite: (state, action: PayloadAction<FavoritedService>) => {
      const idx = state.findIndex((s) => s.id === action.payload.id);
      let next: FavoritedService[];
      if (idx >= 0) {
        next = state.filter((s) => s.id !== action.payload.id);
      } else {
        next = [...state, action.payload];
      }
      saveToStorage(next);
      return next;
    },
  },
});

export const { addFavorite, removeFavorite, toggleFavorite } = favoritesSlice.actions;
export const selectFavorites = (state: { favorites: FavoritedService[] }) => state.favorites;
export const selectIsFavorited = (id: string) => (state: { favorites: FavoritedService[] }) =>
  state.favorites.some((s) => s.id === id);
export default favoritesSlice.reducer;
